exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teacher-remote .team-names{margin:0}@media (min-width:768px){.teacher-remote .team-names{margin:0 2em}}.teacher-remote .form-group{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.teacher-remote .form-group label{padding-top:.25em;-ms-flex-preferred-size:100%;flex-basis:100%}.teacher-remote .form-group label i{float:right}@media (min-width:768px){.teacher-remote .form-group label{-ms-flex-preferred-size:5em;flex-basis:5em}}.teacher-remote .form-group .form-control{-ms-flex:4;flex:4;height:3em;padding:.25em 1em}@media (max-height:480px){.teacher-remote .form-group .form-control{height:2em;margin-bottom:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/components/teamNames.scss
// module id = 1315
// module chunks = 2